<div class="main-content">
  <div class="main-header">
    <a [routerLink]="['/config-workbook']" style="cursor: pointer;"><img src="./assets/Expand-Column-left.svg"
        alt="Image 1" class="r-m20" style="vertical-align: middle;" /></a>
    Config Workbook <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1" /><span class="tooltiptext">Generate
        config workbook.</span></div>
  </div>



  <div class="section" *ngIf="submit">

    <div class="content" style="margin: 10px 16px">
      <p class="text_16_b" style="display: inline-block;margin-top: 10px;">Create Config Workbook </p>
    </div>
    <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
      <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
        <p class="text_12">New Batch Key</p>
        <p class="text_14">{{batchKey}}</p>
      </div>
      <div *ngIf="batchKey"
        style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
        <p class="text_12">Status</p>
        <p *ngIf="batchKey" class="text_14">New </p>
      </div>
      <div *ngIf="batchKey" style="display: inline-block; margin-left: 20px;">
        <p class="text_12">Date </p>
        <p *ngIf="batchKey" class="text_14">{{startDate1 | date: 'dd/MM/yyyy'}} </p>
      </div>
      <div style="float: right;">
        <button mat-flat-button [disabled]="submitDisable || submitNewBtnDisable" class="green-button"
          style="float: right;margin-left: 40px;margin-top: 10px;min-width: 120px;" (click)="onSubmit()"> Submit
        </button>
      </div>
    </div>


    <div class="content" style="margin: 0px 16px 32px 16px;">
      <div *ngFor="let item of tracks; let i = index" class="tracks-class">
        <span (click)="showArray[i]=!showArray[i]"><span *ngIf="!showArray[i]"><img src="./assets/Expand-Column.svg"
              class="expand-button" alt="Expand-Column"></span>
          <span *ngIf="showArray[i]"><img src="./assets/Expand-Column-svg.svg" class="expand-button" alt="Expand-Column"></span><button
            mat-button>{{item}}</button>
        </span>
        <div *ngIf="showArray[i]">
          <mat-radio-group>
            <div *ngFor="let configItem of configDateNew; let i=index">
              <ng-container class="b-spacing" *ngIf="item === configItem.TRACK">
                <div class="item" style="float: left; width:50%;">
                  <span>
                    <mat-checkbox class="example-radio-button" (change)="onChange($event,configItem.APPLICATION,item,i)"
                      [disableRipple]="true" (click)="$event.preventDefault();configPopUp(configItem,i)"
                      [value]="configItem.APPLICATION" [checked]="configItem.saveStatus" type="Checkbox">
                      {{configItem.APPLICATION}}
                    </mat-checkbox>
                  </span>

                  <div>
                    <div>
                      <div class="gray-bg">
                        <p class="font-w-b">Workbook Template</p>
                        <label style="display: block;"
                          (change)="radioChange($event,configItem.APPLICATION,fileName1,i,item)"> <input type="radio"
                            [disabled]="!configItem.saveStatus" class="form-control"
                            [checked]="configItem.defaultTemplate && configItem.saveStatus"
                            (change)="configDateNew[i].saveStatus" name="{{configDateNew[i].APPLICATION}}"><span style="margin-top: -20px;
                      vertical-align: middle;
                      display: inline-block;">{{fileName1}}</span></label>
                        <label (change)="radioChange($event,configItem.APPLICATION,fileName2,i,item)"> <input
                            type="radio" class="form-control" [disabled]="!configItem.saveStatus"
                            [checked]="!configItem.defaultTemplate && configItem.saveStatus"
                            (change)="configDateNew[i].saveStatus1" name="{{configDateNew[i].APPLICATION}}"><span style="margin-top: -20px;
                      vertical-align: middle;
                      display: inline-block;">{{fileName2}}<div class="tooltip"><img src="./assets/Info.svg"
                                alt="Image 1" class="tool-info" /><span class="tooltiptext1">Supported file format:
                                .xlsx</span></div></span></label>
                        <div *ngIf="showArray2[i]">
                          <div><input [hidden]="true" #fileInput type="file" name="fileData"
                              (change)="onFileSelected($event,configItem.APPLICATION,i)" /></div>
                          <div class="form-control1 upload-icon" (click)="fileInput.value=null;fileInput.click()"> {{configItem.fileName}}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </mat-radio-group>

        </div>
      </div>
    </div>
  </div>

  <div class="section" *ngIf="!submit">

    <div class="content" style="margin: 10px 16px">
      <p class="text_16_b" style="display: inline-block;margin-top: 10px;">Create Config Workbook </p>
    </div>
    <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
      <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
        <p class="text_12">New Batch Key</p>
        <p class="text_14">{{batchKey}}</p>
      </div>
      <div *ngIf="batchKey"
        style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
        <p class="text_12">Status</p>
        <p *ngIf="batchKey" class="text_14">New </p>
      </div>
      <div *ngIf="batchKey" style="display: inline-block; margin-left: 20px;">
        <p class="text_12">Date </p>
        <p *ngIf="batchKey" class="text_14">{{startDate1 | date: 'dd/MM/yyyy'}} </p>
      </div>
      <div style="float: right;">
        <button mat-flat-button [disabled]="submitNewBtnDisable" class="green-button"
          style="float: right;margin-left: 40px;margin-top: 10px;min-width: 120px;" (click)="onWorkbookSubmit()">
          Generate Workbook </button>
        <div *ngIf="!editBtnDisable"
          style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #0D8390; font-size: 12px!important;">
          <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;cursor: pointer;"
            (click)="editConfig()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11" stroke="#0D8390" stroke-width="2" />
              <path
                d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
                fill="#0D8390" />
            </svg>
          </div> <span style="font-weight: bold; font-size: 12px;cursor: pointer" (click)="editConfig()">Edit
            Configurations</span>
        </div>
        <div *ngIf="editBtnDisable"
          style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #ADB6BF; font-size: 12px!important; cursor: no-drop;">
          <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11" stroke="#ADB6BF" stroke-width="2" />
              <path
                d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
                fill="#ADB6BF" />
            </svg>
          </div> <span style="font-weight: bold; font-size: 12px;">Edit Configurations</span>
        </div>
      </div>
    </div>


    <div class="content" style="margin: 0px 16px 32px 16px;">

      <div *ngFor="let item of tracks; let i = index" class="tracks-class">
        <span (click)="showArray[i]=!showArray[i]"><span *ngIf="!showArray[i]"><img src="./assets/Expand-Column.svg"
              class="expand-button" alt="Expand-Column"></span>
          <span *ngIf="showArray[i]"><img src="./assets/Expand-Column-svg.svg" class="expand-button" alt="Expand-Column"></span><button
            mat-button>{{item}}</button>
        </span>
        <div *ngIf="showArray[i]">
          <mat-radio-group>
            <div *ngFor="let configItem of configDateNew; let i=index">
              <ng-container class="b-spacing" *ngIf="item === configItem.TRACK">
                <div class="item" style="float: left; width:50%;">
                  <span>
                    <mat-checkbox class="example-radio-button" (change)="onChange($event,configItem.APPLICATION,item,i)"
                      [disableRipple]="true" (click)="$event.preventDefault();configPopUp(configItem,i)"
                      [value]="configItem.APPLICATION" [checked]="configItem.saveStatus" type="Checkbox">
                      {{configItem.APPLICATION}}
                    </mat-checkbox>
                  </span>

                  <div>
                    <div>
                      <div class="gray-bg">
                        <p class="font-w-b">Workbook Template</p>
                        <label style="display: block;"
                          (change)="radioChange($event,configItem.APPLICATION,fileName1,i,item)"> <input type="radio"
                            [disabled]="!configItem.saveStatus" class="form-control"
                            [checked]="configItem.defaultTemplate && configItem.saveStatus"
                            (change)="configDateNew[i].saveStatus" name="{{configDateNew[i].APPLICATION}}"><span style="margin-top: -20px;
                      vertical-align: middle;
                      display: inline-block;">{{fileName1}}</span></label>
                        <label (change)="radioChange($event,configItem.APPLICATION,fileName2,i,item)"> <input
                            type="radio" class="form-control" [disabled]="!configItem.saveStatus"
                            [checked]="!configItem.defaultTemplate && configItem.saveStatus"
                            (change)="configDateNew[i].saveStatus1" name="{{configDateNew[i].APPLICATION}}"><span style="margin-top: -20px;
                      vertical-align: middle;
                      display: inline-block;">{{fileName2}}<div class="tooltip"><img src="./assets/Info.svg"
                                alt="Image 1" class="tool-info" /><span class="tooltiptext1">Supported file format:
                                .xlsx</span></div></span></label>
                        <div *ngIf="showArray2[i]">                         
                          <div><input [hidden]="true" #fileInput type="file" name="fileData"
                              (change)="onFileSelected($event,configItem.APPLICATION,i)" /></div>
                          <div class="form-control1 upload-icon" (click)="fileInput.value=null;fileInput.click()"> {{configItem.fileName}}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </mat-radio-group>

        </div>
      </div>
    </div>
  </div>
</div>
